module.exports = __webpack_public_path__ + "img/7fba2cc.png";